import type { ErrorEvent } from '@sentry/react';

import { RUNTIME_ENV } from '../envConfig';

import { getFullstorySessionURL, trackFullstoryEvent } from './fullstory';

const summariseSentryEvent = (event: ErrorEvent): string =>
  event.message ?? event.exception?.values?.[0]?.value ?? 'unknown';

// Drop localdev events entirely; otherwise tag the event with the current
// Fullstory session URL (when Fullstory is enabled and has a live session) so
// reviewers can jump from a Sentry error to the deep-linked replay, and drop
// a Fullstory timeline marker carrying the Sentry event id so the reverse
// direction (search Fullstory by sentry_event_id) works too.
export const beforeSendSentryEvent = (event: ErrorEvent): ErrorEvent | null => {
  if (RUNTIME_ENV === 'localdev') {
    return null;
  }
  const fullstorySessionURL = getFullstorySessionURL();
  if (fullstorySessionURL) {
    event.tags = { ...(event.tags ?? {}), fullstory_session_url: fullstorySessionURL };
    if (event.event_id) {
      trackFullstoryEvent('Sentry Error', {
        sentry_event_id: event.event_id,
        message: summariseSentryEvent(event),
      });
    }
  }
  return event;
};
